import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { ExperienceButton } from "./CTA";

const modalities = [
  "Compression",
  "Halo Therapy",
  "Red Light",
  "Cold Plunge",
  "Infrared Sauna",
  "PEMF",
  "Hyperbaric Oxygen",
  "Salt Float"
];

export const Offer = () => (
  <section
    id="offer"
    className="relative overflow-hidden border-t border-white/10"
    style={{ boxShadow: "inset 0 0 120px rgba(230,57,70,0.08)" }}
    data-testid="offer-section"
  >
    <div className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="grid gap-16 lg:grid-cols-2 lg:gap-24"
      >
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Your first session is on us</p>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.95] tracking-tighter md:text-7xl">
            The Recovery<br />Experi<span className="text-rest-red">ence</span>
          </h2>
          <p className="mt-8 max-w-md text-base leading-relaxed text-zinc-400 md:text-lg">
            A complimentary, staff-guided recovery session featuring 2–3 of our signature modalities — selected around
            your goals, your body and how you train.
          </p>
          <div className="mt-10">
            <ExperienceButton id="offer-cta-claim" className="w-full justify-center sm:w-auto" />
          </div>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
            No cost. No commitment. Fully guided.
          </p>
        </div>

        <div className="flex flex-col justify-center">
          <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Your session may feature</p>
          <ul className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2">
            {modalities.map((item, i) => (
              <motion.li
                key={item}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="flex items-center gap-3 bg-rest-base px-5 py-4"
                data-testid={`offer-included-${item.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Check className="h-4 w-4 shrink-0 text-rest-red" />
                <span className="font-display text-sm font-bold uppercase tracking-tight">{item}</span>
              </motion.li>
            ))}
          </ul>
          <p className="mt-6 text-sm text-zinc-500">
            Plus a first look at the Infinity Capsule.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
